import React from 'react'
import RightContentMap from '../../components/RightContentMap'
import { useForm } from "react-hook-form";
import { Button, Input } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import CommonSectionTitle from '../../../App/Components/CommonSectionTitle';


const ReactFormHook = () => {

  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const onSubmit = data => console.log(data);

  console.log(watch("name")); // watch input value by passing the name of it

  return (
    <div className='md:flex'>
      <div className='px-1 pb-10'>
        <RightContentMap />
      </div>

      <div className='md:w-[70%] dark:bg-cDarkBG2 bg-gray-100 rounded-lg shadow-lg p-5'>
        <CommonSectionTitle
        title='React Form Hook'
        withBackLink={true}
        backLinkUrl='/play'
        />
        {/* "handleSubmit" will validate your inputs before invoking "onSubmit"  */}
        <form onSubmit={handleSubmit(onSubmit)} className='space-y-2 pt-5'>

          {/* register your input into the hook by invoking the "register" function */}
          <Input variant='flushed' placeholder='Name'
            {...register("name", {
              required: true,
              minLength: {
                value: 5, message: ": minimum length: 5 chars"
              },
              maxLength: {
                value: 12, message: ": maximum length: 12 chars"
              }
            })} />
          {errors.name && <div>Name is required{errors.name.message}</div>}

          {/* include validation with required or other standard HTML validation rules */}
          <Input variant='flushed' placeholder='Email'
            {...register("email", {
              required: true,
              minLength: {
                value: 5, message: ": minimum length: 5 chars"
              },
              maxLength: {
                value: 12, message: ": maximum length: 12 chars"
              }
            })} />

          {/* errors will return when field validation fails  */}
          {errors.email && <div>Email is required{errors.email.message}</div>}

          <div className="pt-5">
            <Button colorScheme='green' type='submit'>Save All</Button>
          </div>
        </form>

        <Link to={'reset-password-form'} >
          <Button colorScheme='cyan' className='mt-5'>Reset Password Form</Button>
        </Link>
      </div>

    </div>
  )
}

export default ReactFormHook